import { atom } from "recoil";

export const createDepositLadderListState = () => ({
	loaded: false,
	data: [],
	error: { text: "", code: 0, timestamp: 0 },
	currentSearch: "",
	sorting: { sortingColumn: { order: "DESC", column: "id" }, isDescending: true },
	pagination: { current: 1, total: 0, count: 0 },
});

export const depositLadderStore = atom({
	key: "depositLadderStore",
	default: createDepositLadderListState(),
});

export const depositLadderArchiveStore = atom({
	key: "depositLadderArchiveStore",
	default: createDepositLadderListState(),
});

export const formatClaimPeriod = (claimPeriod) => {
	const hours = Number(claimPeriod);

	if (Number.isFinite(hours) && hours > 0 && hours % 24 === 0) {
		return { claimPeriod: hours / 24, claimPeriodUnit: "days" };
	}

	return { claimPeriod, claimPeriodUnit: "hours" };
};

export const getClaimPeriodHours = (claimPeriod, claimPeriodUnit) => {
	const value = Number(claimPeriod);

	return claimPeriodUnit === "days" ? value * 24 : value;
};

export const createDepositLadderForm = () => ({
	show: false,
	loaded: true,
	formMode: "add",
	id: null,
	name: "",
	title: "",
	titleType: "local",
	subtitle: "",
	subtitleType: "local",
	buttonText: "",
	buttonTextType: "local",
	minDeposit: "",
	maxBonusAmount: "",
	wager: "",
	cap: "",
	claimPeriod: "",
	claimPeriodUnit: "hours",
	mode: "all",
	active: 0,
	partnerUids: "",
	allowedCountries: [],
	allowedBrowserLanguages: [],
	excludedBrowserLanguages: [],
	steps: [
		{
			depositNumber: 1,
			rewardType: "deposit",
			bonusPercent: "",
			minDeposit: "",
			maxBonusAmount: "",
			wager: "",
			cap: "",
			fsGameId: null,
			fsBetAmount: null,
			fsCurrency: null,
			fsExpirationDays: null,
			fsParts: null,
		},
	],
});

export const depositLadderFormStore = atom({
	key: "depositLadderFormStore",
	default: createDepositLadderForm(),
});

export const createDepositLadderStatisticsFilters = () => ({
	date: null,
	mode: "",
	refererUid: "",
	selectedLadder: null,
	status: "",
	uid: "",
});

export const depositLadderStatisticsStore = atom({
	key: "depositLadderStatisticsStore",
	default: {
		loaded: false,
		data: {
			byLadder: [],
			byStep: [],
			summary: null,
		},
		error: { text: "", code: 0, timestamp: 0 },
		filters: createDepositLadderStatisticsFilters(),
		ladderOptions: [],
		ladderOptionsLoading: false,
	},
});

export const depositLadderStatisticsUsersStore = atom({
	key: "depositLadderStatisticsUsersStore",
	default: {
		loaded: false,
		data: [],
		error: { text: "", code: 0, timestamp: 0 },
		pagination: { current: 1, total: 0, count: 0 },
	},
});
